import { useEffect, useState } from 'react';
import { useGetApiData } from '@grc/ui-utility';
import { getAnySettings } from '../../service/api/get-any-settings';
import { orderSettingUrl } from '../../common/constants/url-constants';
import { orderService } from '../../common/constants/constants';

const STATIC_OWNER_ID = '42c0e604-9b3e-44d9-b029-77e0a77180e9';

export interface ITransportationMode {
  id: number;
  displayName?: string;
  isActive?: boolean;
}

export interface IServiceChargeDetail {
  id: string;
  serviceChargeName?: string;
  isStandardService?: boolean;
  isActive?: boolean;
}

export function useShipmentSettings() {
  const { fetchData } = useGetApiData();
  const [transportationModes, setTransportationModes] = useState<
    ITransportationMode[]
  >([]);
  const [serviceCharges, setServiceCharges] = useState<IServiceChargeDetail[]>(
    []
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const load = async () => {
      setIsLoading(true);
      const settings: any = await getAnySettings(
        orderSettingUrl,
        fetchData,
        orderService,
        { ownerId: STATIC_OWNER_ID }
      );
      if (!isCancelled) {
        setTransportationModes(settings?.TransportationModeDetails ?? []);
        setServiceCharges(settings?.ServiceChargeDetails ?? []);
        setIsLoading(false);
      }
    };

    load();

    return () => {
      isCancelled = true;
    };
  }, [fetchData]);

  return { transportationModes, serviceCharges, isLoading };
}

export default useShipmentSettings;
